"use strict";

let Backbone = require('dibs-backbone');
let SoaModel = require('bunsen/models/SoaModel');
let AuthorizedRoles = require('bunsen/collections/identity/AuthorizedRoles');

let AvailableAction = SoaModel.extend({
    relations : [
        {
            key : 'authorizedRoles',
            type : Backbone.Many,
            collectionType : AuthorizedRoles
        }
    ],

    // ----------------------------------------------------------------------
    // getters :
    getRoles () {
        return this.get('authorizedRoles');
    }
});

module.exports = AvailableAction;



// WEBPACK FOOTER //
// ./~/bunsen/models/AvailableAction.es.js